angular.module('manage-content', [
  'manage-assets',
  'create-asset',
  'new-plain-editor',
  'new-wysiwyg-editor',
]);
